@let isWelcomeStep = $isWelcomeStep();
@let isRootPage = $isRootPage();
@let returnLink = $returnLink();

<section tuiPlatform="ios">
  <tui-app-bar class="x-white h-[64px]!">
    @if (!isWelcomeStep && returnLink) {
      <button
        tuiIconButton
        type="button"
        class="me-4"
        tuiSlot="start"
        appearance="transparent"
        (click)="backClick()"
      >
        <tui-icon
          [style.border-width.rem]="0.25"
          class="white-bg rounded-full h-[34px]! w-[34px]!"
          icon="@tui.arrow-left"
        ></tui-icon>
      </button>
    }
    <label tuiTitle class="x-text-dark-main">
      @if (isWelcomeStep) {
        <span class="text-center x-font-body-3-bold-important"
          >Мастер выполнения</span
        >
      } @else if (isRootPage) {
        <span class="text-center x-font-body-3-bold-important"
          >Выбор сценария</span
        >
      } @else {
        <span
          class="text-center x-font-body-3-bold-important truncate"
          [title]="$currentWorkflowSubTitle()"
          >{{ $currentWorkflowTitle() }}</span
        >
      }
      <span
        tuiSubtitle
        class="x-font-body-4-important truncate"
        [title]="$currentWorkflowSubTitle()"
        >{{ $currentWorkflowSubTitle() }}</span
      >
    </label>
    <button
      tuiIconButton
      type="button"
      tuiSlot="end"
      [routerLink]="$baseRoute() + '/summary'"
      appearance="transparent"
    >
      <tui-icon
        [style.border-width.rem]="0.25"
        class="white-bg rounded-full h-[34px]! w-[34px]!"
        icon="@tui.x"
      ></tui-icon>
    </button>
  </tui-app-bar>
</section>
